module.exports = __webpack_public_path__ + "fonts/dk-otago.8da5586.woff";


//////////////////
// WEBPACK FOOTER
// ./src/components/posters/foxy-strollin/fonts/dk-otago.woff
// module id = 386
// module chunks = 0